import { apiClient } from '../client'

/**
 * Creates an client that can be used directly in a window context to make authenticated requests via access token.
 *
 * @param accessToken - The access token to use for authentication.
 * @returns A client that can be used to make authenticated requests.
 */
export const makeAuthWindowClient = (accessToken: string) =>
  apiClient.extend({
    hooks: {
      beforeRequest: [
        async (request) => {
          request.headers.set('Authorization', `Bearer ${accessToken}`)
        },
      ],
    },
  })
